import { useTrackingDashboard } from './useTrackingDashboard';

export * from './useTrackingApply';
export * from './useTrackingBase';
export * from './useTrackingDashboard';

// retain original useTracking shape for backwards compatibility
export const useTracking = (accountId: string) => {
  return useTrackingDashboard(accountId);
};
